import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAddCarrier extends Layout {
    addCarrierSlideOut: Panel;
    sourceAddCarrier: DataSource;
    sourcePayee: DataSource;
    textboxAddCarrierName: Textbox;
    textboxAddCarrierNbr: Textbox;
    textboxAddCarrierType: Textbox;
    textboxCarrierId: Textbox;
    textboxEmailAddress: Textbox;
    textboxPacketContactName: Textbox;
}
